import { ProductSummaryItem } from '@backbase/data-ang/arrangements';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BeneficiaryListState, defaultBeneficiaryTabsConfig, ListState } from '../../beneficiary-selector-ui.component';
import { BeneficiaryList } from '../../enums/beneficiary-list';
import { CatalogItem } from 'banesco-catalogues-api';

@Component({
  selector: 'bn-beneficiary-tabs',
  templateUrl: 'beneficiary-tabs.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BeneficiaryTabsComponent implements OnInit {
  static _id = 0;
  readonly tabsId = `beneficiaryTabs${BeneficiaryTabsComponent._id++}`;
  readonly contactsListId = `beneficiaryContactsList${BeneficiaryTabsComponent._id++}`;
  readonly accountsListId = `beneficiaryAccountsList${BeneficiaryTabsComponent._id++}`;
  readonly cataloguesListId = `beneficiaryCataloguesList${BeneficiaryTabsComponent._id++}`;
  /**
   * List of accounts
   */
  @Input() accounts!: ProductSummaryItem[];

  /**
   * List of contacts
   */
  @Input() contacts!: any[];

  /**
   * List of catalogues
   */
  @Input() catalogues!: CatalogItem[];

  /**
   * Total count of accounts
   */
  @Input() totalAccounts = 0;

  /**
   * Total count of contacts
   */
  @Input() totalContacts = 0;

  /**
   * Total count of contacts
   */
  @Input() totalCatalogues = 0;

  /**
   * Selected account event emitter
   */
  @Output() selectedAccount = new EventEmitter<ProductSummaryItem>();

  /**
   * Selected contact event emitter
   */
  @Output() selectedContact = new EventEmitter<any>();

  /**
   * Selected catalog event emitter
   */
  @Output() selectedCatalog = new EventEmitter<CatalogItem>();

  /**
   * Trigger fetching more beneficiary items
   */
  @Output() fetchMoreItems = new EventEmitter<BeneficiaryList>();

  /**
   * Manual edit event emitter
   */
  @Output() manualEdit = new EventEmitter<boolean>();

  /**
   * Search state, has truthy value if has search query
   */
  @Output() searching = new EventEmitter<boolean>();

  /**
   * State of the list from parent component
   */
  @Input() listState!: BeneficiaryListState;

  /**
   * Tabs configuration
   */
  @Input() tabsConfig!: Array<BeneficiaryList>;

  /**
   * Dropdown status
   */
  @Input() isDropdownOpen = false;

  activeTab!: BeneficiaryList | undefined;

  /** Flag which determines if we can enter data manually
   * Default value is `true`
   */
  @Input() canEditManually = true;

  notFoundLabel = $localize`:@@beneficiary-tabs.not-found.label:Oops! We couldn´t find what your are looking for. Try again.`;

  readonly listingState = ListState;
  readonly beneficiaryList = BeneficiaryList;

  private onLoadMore() {
    this.fetchMoreItems.emit(this.activeTab);
  }

  ngOnInit() {
    this.tabsConfig = this.tabsConfig || defaultBeneficiaryTabsConfig;
    this.activeTab = this.tabsConfig[0];
  }

  showTabs(): boolean {
    return (
      this.isDropdownOpen &&
      Object.values(this.listState || {}).some((state) => state !== ListState.NO_RESULT) &&
      !this.isNoTabsConfigured()
    );
  }

  isNoTabsConfigured(): boolean {
    return this.tabsConfig && this.tabsConfig.length < 2;
  }

  selectAccount(account: ProductSummaryItem) {
    account.additions = { ...account.additions, ownAccount: 'true' };
    this.selectedAccount.emit(account);
  }

  selectContact(contact: any) {
    this.selectedContact.emit(contact);
  }

  selectCatalog(catalog: CatalogItem) {
    this.selectedCatalog.emit(catalog);
  }

  setActiveTab(event: Event, tabName: BeneficiaryList) {
    this.activeTab = tabName;
  }

  emitManualDetails() {
    this.manualEdit.emit(true);
  }

  onRangeChange() {
    if (this.activeTab && this.listState[this.activeTab] === this.listingState.LIST) {
      this.onLoadMore();
    }
  }

  refreshList() {
    this.onLoadMore();
  }

  trackById(_index: number, item: ProductSummaryItem | any): string {
    return item.id;
  }
}
